export function isTauri(): boolean {
  return '__TAURI_INTERNALS__' in window;
}

export function isTauriMacOS(): boolean {
  return isTauri() && navigator.platform.startsWith('Mac');
}
